export const appendLink = (url: string, linkId: string): void => {
  const linkNotAvailable = !document.querySelector(`link[id=${linkId}]`);

  if (linkNotAvailable) {
    const link = document.createElement('link');
    link.setAttribute('id', linkId);
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', url);
    document.getElementsByTagName('head')[0].appendChild(link);
  }
};

export interface IScriptAttr {
  src: string;
  integrity?: string;
}

export const appendScript = (scriptAttr: IScriptAttr, id: string): void => {
  const scriptFound = document.querySelector(`script[id=${id}]`);

  if (!scriptFound) {
    const script = document.createElement('script');
    const {
      integrity,
      src,
    } = scriptAttr;
    script.src = src;
    script.async = true;
    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
    }
    script.setAttribute('id', id);
    document.body.appendChild(script);
  }
};

export const containsHTML = (text: string): boolean => /<[a-z][\s\S]*>/i.test(text);
